import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Custom Domains
function pathCustomDomains(domainId=null) {
  if (domainId) {
      return `custom-domains/${domainId}`;
  } else {
      return `custom-domains`;
  }
}

export function createCustomDomains(successCallback, errorCallback, data) {
  postAuth({
    "path": pathCustomDomains(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteCustomDomains(successCallback, errorCallback, domainId) {
  deleteAuth({
    "path": pathCustomDomains(domainId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postVerifyCustomDomains(successCallback, errorCallback, domainId) {
  postAuth({
    "path": `custom-domains/${domainId}/verify`,
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageCustomDomains(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-custom-domains`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewCustomDomainShforms(domainId=null) {
  if (domainId) {
      return `view/custom-domain-shforms/${domainId}`;
  } else {
      return `view/custom-domain-shforms`;
  }
}

export function getViewCustomDomainShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewCustomDomainShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Custom Pages
function pathCustomPages(pageId=null) {
  if (pageId) {
      return `custom-pages/${pageId}`;
  } else {
      return `custom-pages`;
  }
}

export function createCustomPages(successCallback, errorCallback, data) {
  postAuth({
    "path": pathCustomPages(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchCustomPages(successCallback, errorCallback, data, pageId) {
  patchAuth({
    "path": pathCustomPages(pageId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteCustomPages(successCallback, errorCallback, pageId) {
  deleteAuth({
    "path": pathCustomPages(pageId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageCustomPages(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-custom-pages`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewCustomPageShforms(pageId=null) {
  if (pageId) {
      return `view/custom-page-shforms/${pageId}`;
  } else {
      return `view/custom-page-shforms`;
  }
}

export function getViewCustomPageShforms(successCallback, errorCallback, pageId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewCustomPageShforms(pageId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}









